/**
 *
 * ProfilePage
 *
 */
import * as React from 'react';
import { Box, Container, Paper, Stack } from '@mui/material';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SecurityAndPasswords } from '../SecurityAndPasswords';
import { selectAuthProvider } from 'app/providers/AuthProvider/slice/selectors';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

interface Props {}

export function ProfilePage(props: Props) {
  const { loadUser } = useSelector(selectAuthProvider);
  const location = useLocation();

  if (!loadUser.data) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <Container>
        <Box my={4}>
          <Paper sx={{ p: 4 }}>
            <Stack spacing={6}>
              <Routes>
                <Route path={'security/*'} element={<SecurityAndPasswords />} />

                <Route
                  path={'*'}
                  element={<Navigate to={'security'} replace />}
                />
              </Routes>
            </Stack>
          </Paper>
        </Box>
      </Container>
    </>
  );
}
